import { decodeToken } from 'react-jwt'
import irisApi from '@services/iris-api'

export type GetCustomTokensOutput = { idToken: string; niloToken: string }
export const getCustomTokens = async (idToken: string) => {
  const headers = { Authorization: '' }
  const { data } = await irisApi.post<GetCustomTokensOutput>(`v1/auth-token`, { id_token: idToken }, { headers })
  return data
}

export const isTokenAboutToExpire = (token: string): boolean => {
  const decodedToken: any = decodeToken(token)
  if (!decodedToken) return true

  const now = new Date()
  const expirationDate = new Date(0)
  expirationDate.setUTCSeconds(decodedToken.exp)
  const thresholdDate = now.setHours(now.getHours() + 1)
  return expirationDate.valueOf() <= thresholdDate.valueOf()
}
